<template>
  <div>
    <b-col md="12">
      <card class="data-card">
        <b-row no-gutters>
          <b-col no-gutters>
            <h2 class="card-header p-0 card-header-text pb-3 text-right">
              فلیتر تراکنش های پرفکت مانی
            </h2>
          </b-col>
        </b-row>
        <b-row no-gutters>
          <b-col no-gutters>
            <BaseDatePicker/>
          </b-col>
        </b-row>
        <b-row no-gutters>
          <b-col no-gutters class="mt-5">
            <b-button
              size="sm"
              class="p-2 pl-4 pr-4"
              type="submit"
              variant="primary"
            >اعمال فیلتر
            </b-button
            >
          </b-col>
        </b-row>
      </card>
      <card class="data-card mt-4 mr-3 ml-3" :show-footer-line="true">
        <b-row no-gutters>
          <b-col no-gutters>
            <h1 class="card-header">تراکنش های پرفکت مانی</h1>
          </b-col>
        </b-row>
        <b-skeleton-table
          v-if="loading"
          :rows="10"
          :columns="4"
          :table-props="{ bordered: true, striped: true }"
        >
        </b-skeleton-table>
        <b-row v-if="!loading">
          <b-col md="12">
            <!-- <h1 class="section-header">کیف های پول</h1> -->
            <b-card class="wallets-table" no-body>
              <b-table
                emptyText="تاریخچه ای یافت نشد"
                :items="histories"
                :fields="fields"
                show-empty
                responsive
                small
              >
                <template #cell(type)="row">
                  <b-button size="sm" variant="outline-primary">
                    {{ row.item.type }}
                  </b-button>
                </template>

                <template #cell(date)="row">
                    {{ row.item.date }}
                </template>

                <template #cell(status)="row">
                  <b-button size="sm" variant="outline-primary">
                    {{ row.item.status }}
                  </b-button>
                </template>

                <template #cell(toAmount)="row">
                    {{ row.item.toAmount }}
                </template>

                <template #cell(fromAmount)="row">
                    {{ row.item.fromAmount }}
                </template>

                <template #cell(user)="row">
                  <b-button
                    :to="'/user-profile/' + row.item.user"
                    size="sm"
                    variant="primary"
                  >
                    مشاهده اطلاعات کاربر
                  </b-button>
                </template>

                <template #cell(voucher)="row">
                  {{ row.item.voucher }}
                </template>
              </b-table>
            </b-card>
            <div class="paginationNav">
              <b-row>
                <b-col class="mt-4">
                  <BasePagination
                    :showNext="showNext"
                    :showPrev="currentPage !== 0"
                    @onClick="handlePaginationClick"
                  />
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </card>
    </b-col>
  </div>
</template>
<script>

import CryptoIcons from "@/components/CryptoIcons";
import BasePagination from "@/components/BasePagination.vue";
import filterAndPaginate from "@/mixins/filterAndPaginate";
import BaseDatePicker from "@/components/Inputs/BaseDatePicker";
import {fetchPerfectMoneyReports} from "@/httpservices/PerfectMoney"
import dateHelper from "@/utils/DateHelper";


export default {
  mixins: [filterAndPaginate],

  components: {
    CryptoIcons,
    BaseDatePicker,
    BasePagination,
  },

  data() {
    return {

      TYPES: {
        VoucherCreate: "برداشت",
        VoucherRedeem: "واریز",
        Withdraw: "برداشت",
        Buy: "تبدیل",
        Sell: "تبدیل",
      },

      STATUS: {
        Filled: "تکمیل شده",
        Canceled: "کنسل شده",
        Open: "باز",
      },

      fields: [
        {
          key: "type",
          label: "نوع",
          sortDirection: "desc",
          class: "text-right",
        },
        {
          key: "date",
          label: "تاریخ",
          sortable: true,
          class: "text-center",
        },
        {
          key: "status",
          label: "وضعیت",
          sortable: true,
          class: "text-center",
        },
        {
          key: "toAmount",
          label: "To Amount",
          class: "text-center",
        },
        {
          key: "fromAmount",
          label: "from  Amount",
          class: "text-center",
        },
        {
          key: "user",
          label: "کاربر",
          class: "text-center",
        },
        {
          key: "voucher",
          label: "کد",
          class: "text-center",
        },
        {
          key: "peer",
          label: "کیف پول مقصد",
          class: "text-center",
        },
      ],
      histories: [],
      loading: false,
      currentPage: 0,
      filterData: {
        fromDate: null,
        toDate: null,
        pageSize: 25,
      },
    };
  },

  mounted() {
    this.getHistory();
  },

  methods: {
    async getHistory() {
      this.loading = true;
      try {
        const res = (await fetchPerfectMoneyReports({
          page: this.currentPage,
          Start: this.filterData.fromDate,
          End: this.filterData.toDate,
        })).data;
        this.histories = res.data.map(item => {
          const voucher = item.voucher || [];
          return {
            ...item,
            type: this.TYPES[item.type] || 'نا معلوم',
            date: dateHelper.faDateTime(item.date),
            status: this.STATUS[item.status] || 'نا معلوم',
            toAmount:item.toAmount,
            fromAmount:item.fromAmount,
            user:item.accountId,
            voucher:voucher.join(' - '),
            peer:item.peer,
          }
        });
      } catch (e) {
        console.log(e)
      }
      this.loading = false;
    },


  },
};
</script>

